import styled from 'styled-components'

export const LessonFinderContainer = styled.div`
  height: 95vh;
  /* display: grid; */
  background: var(--white);
`

export const LessonPlanSectionTitles = styled.div`
  text-align: center;
  text-decoration: underline;
`
